import { ApplicationConfig } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth, connectAuthEmulator } from '@angular/fire/auth';
import { getApp } from '@angular/fire/app';
import {
  provideFirestore,
  connectFirestoreEmulator,
  initializeFirestore,
} from '@angular/fire/firestore';
import {
  getFunctions,
  provideFunctions,
  connectFunctionsEmulator,
} from '@angular/fire/functions';
import {
  getStorage,
  provideStorage,
  connectStorageEmulator,
} from '@angular/fire/storage';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideRouter(routes),
    provideIonicAngular({
      animated: true,
      mode: 'ios', // iOS animations are smoother
      swipeBackEnabled: true,
      navAnimation: undefined, // Use default for best performance
    }),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => {
      const auth = getAuth();
      if (environment.useEmulators) {
        const host = window.location.hostname;
        connectAuthEmulator(auth, `http://${host}:9099`, {
          disableWarnings: true,
        });
      }
      return auth;
    }),
    provideFirestore(() => {
      const app = getApp();
      const firestore = initializeFirestore(app, {
        experimentalForceLongPolling: true,
      });
      if (environment.useEmulators) {
        const host = window.location.hostname;
        connectFirestoreEmulator(firestore, host, 8080);
      }
      return firestore;
    }),
    provideFunctions(() => {
      const functions = getFunctions();
      if (environment.useEmulators) {
        const host = window.location.hostname;
        connectFunctionsEmulator(functions, host, 5001);
      }
      return functions;
    }),
    provideStorage(() => {
      const storage = getStorage();
      if (environment.useEmulators) {
        const host = window.location.hostname;
        connectStorageEmulator(storage, host, 9199);
      }
      return storage;
    }),
  ],
};
